import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  Paper,
  Radio,
  RadioGroup,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CloseIcon from "@material-ui/icons/Close";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import LibraryBooksIcon from "@material-ui/icons/LibraryBooks";
import ListAltIcon from "@material-ui/icons/ListAlt";
import clsx from "clsx";
import { ExamQuestions, ListExam } from "models/managerTest";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { dateTimeToFormatYYYYHHMM } from "utils/dateTimeFormat";
import { deduplicateQuestions } from "utils/examPreview";

export interface PickOldExamProps {
  data: ListExam[];
  setCreateQuestion: (e: any) => void;
  listQuestionsAdded: any;
  setListQuestionsAdded: (e: any) => void;
  setIsPickOldExam: (e: any) => void;
  setIsShowMainExam: (e: any) => void;
  setInitialRandomCount: (value: number | undefined) => void;
  valueForm?: any;
  setValueForm?: (e: any) => void;
}

export default function PickOldExamComponent({
  data,
  setCreateQuestion,
  setListQuestionsAdded,
  listQuestionsAdded,
  setIsPickOldExam,
  setIsShowMainExam,
  setInitialRandomCount,
}: PickOldExamProps) {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
    },
    sidebarCard: {
      backgroundColor: "#FFFFFF",
      borderRadius: 16,
      border: "1px solid #E2E8F0",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.04)",
      padding: "20px",
      position: "sticky",
      top: 90,
      maxHeight: "calc(100vh - 120px)",
      overflowY: "auto",
      [theme.breakpoints.down("sm")]: {
        position: "relative",
        top: 0,
        maxHeight: "none",
        marginBottom: 16,
      },
    },
    sidebarTitle: {
      fontWeight: 800,
      color: "#0F172A",
      fontSize: "0.95rem",
      display: "flex",
      alignItems: "center",
      gap: 8,
      marginBottom: 16,
      paddingBottom: 12,
      borderBottom: "1px solid #F1F5F9",
    },
    statChipRow: {
      display: "flex",
      flexDirection: "column",
      gap: 8,
      marginBottom: 16,
    },
    statRowItem: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "8px 12px",
      borderRadius: 10,
      fontSize: "0.85rem",
      fontWeight: 600,
    },
    examNavItem: {
      padding: "10px 12px",
      borderRadius: 10,
      backgroundColor: "#F8FAFC",
      border: "1px solid #E2E8F0",
      marginBottom: 8,
      cursor: "pointer",
      transition: "all 0.2s ease",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      "&:hover": {
        backgroundColor: "#EFF6FF",
        borderColor: "#BFDBFE",
      },
    },
    accordionCard: {
      borderRadius: "16px !important",
      border: "1px solid #E2E8F0",
      boxShadow: "0 4px 16px rgba(15, 23, 42, 0.03) !important",
      marginBottom: "16px !important",
      overflow: "hidden",
      "&::before": {
        display: "none",
      },
    },
    accordionSummary: {
      backgroundColor: "#F8FAFC",
      padding: "12px 20px",
      borderBottom: "1px solid #E2E8F0",
    },
    questionCard: {
      backgroundColor: "#FFFFFF",
      borderRadius: 14,
      border: "1px solid #E2E8F0",
      padding: "18px 20px",
      marginBottom: 14,
      width: "100%",
      position: "relative",
      boxShadow: "0 2px 8px rgba(15, 23, 42, 0.02)",
      transition: "all 0.2s ease",
      cursor: "pointer",
      userSelect: "none",
      "&:hover": {
        borderColor: "#CBD5E1",
        boxShadow: "0 4px 14px rgba(15, 23, 42, 0.05)",
      },
    },
    questionSelected: {
      backgroundColor: "#F0FDFA",
      borderColor: "#99F6E4",
    },
    questionTitle: {
      fontWeight: 700,
      fontSize: "0.95rem",
      color: "#0F172A",
      marginBottom: 10,
    },
    answerText: {
      fontSize: "0.875rem",
      color: "#334155",
    },
    answerRightText: {
      fontWeight: 700,
      color: "#059669",
    },
    inputShuffleModal: {
      border: "1px solid #CBD5E1",
      borderRadius: 8,
      padding: "6px 12px",
      width: 80,
      textAlign: "center",
      fontWeight: 700,
      fontSize: "0.95rem",
      outline: "none",
      "&:focus": {
        borderColor: "#2563EB",
        boxShadow: "0 0 0 2px rgba(37, 99, 235, 0.2)",
      },
    },
    stickyFooter: {
      position: "sticky",
      bottom: 16,
      zIndex: 100,
      backgroundColor: "rgba(255, 255, 255, 0.94)",
      backdropFilter: "blur(12px)",
      borderRadius: 16,
      padding: "14px 24px",
      border: "1px solid #E2E8F0",
      boxShadow: "0 10px 30px rgba(15, 23, 42, 0.1)",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginTop: "auto",
      [theme.breakpoints.down("sm")]: {
        padding: "12px 14px",
        bottom: 8,
        borderRadius: 14,
        gap: 8,
        width: "100%",
      },
    },
    btnPrimary: {
      background: "linear-gradient(135deg, #2563EB 0%, #1D4ED8 100%)",
      color: "#FFFFFF",
      borderRadius: 12,
      padding: "10px 24px",
      fontWeight: 700,
      fontSize: "0.9rem",
      textTransform: "none",
      boxShadow: "0 4px 14px rgba(37, 99, 235, 0.3)",
      "&:hover": {
        background: "linear-gradient(135deg, #1D4ED8 0%, #1E40AF 100%)",
      },
      [theme.breakpoints.down("sm")]: {
        flex: 1,
        padding: "12px 14px",
        fontSize: "0.85rem",
      },
    },
    btnSecondary: {
      backgroundColor: "#F1F5F9",
      color: "#475569",
      borderRadius: 12,
      padding: "10px 20px",
      fontWeight: 600,
      fontSize: "0.9rem",
      textTransform: "none",
      border: "1px solid #CBD5E1",
      "&:hover": {
        backgroundColor: "#E2E8F0",
        color: "#0F172A",
      },
      [theme.breakpoints.down("sm")]: {
        flex: 1,
        padding: "12px 14px",
        fontSize: "0.85rem",
      },
    },
  }));

  const classes = useStyles();
  const { t } = useTranslation();
  const [openModal, setOpenModal] = useState(false);
  const [valueModalConfirm, setValueModalConfirm] = useState("");
  const [valueInputConfirm, setValueInputConfirm] = useState<any>("");

  const uniqueSelectedQuestions = deduplicateQuestions(listQuestionsAdded);
  const uniqueSelectedCount = uniqueSelectedQuestions.length;
  const getUniqueCount = (questions: ExamQuestions[]) =>
    deduplicateQuestions(questions as any[]).length;

  const handleClose = () => {
    setOpenModal(false);
  };

  const getItemKey = (q: any) =>
    q?.id ? `id:${q.id}` : `exam:${q?.examId}-q:${q?.questionId || q?.question?.id}`;

  const handleAddQuestion = (question: ExamQuestions) => {
    const key = getItemKey(question);
    const findItemIndex = listQuestionsAdded.findIndex((x: any) => getItemKey(x) === key);
    if (findItemIndex < 0) {
      setListQuestionsAdded([...listQuestionsAdded, { ...question }]);
    } else {
      const newListAdded = listQuestionsAdded.filter((item: any) => getItemKey(item) !== key);
      setListQuestionsAdded(newListAdded);
    }
  };

  const handleAddAllQuestion = (questions: ExamQuestions[], event: any) => {
    const checked = event.target.checked;
    if (!checked) {
      const keysToRemove = new Set((questions || []).map((q) => getItemKey(q)));
      const filterArray = listQuestionsAdded.filter((q: any) => !keysToRemove.has(getItemKey(q)));
      setListQuestionsAdded(filterArray);
    } else {
      const rawCount = (questions || []).length;
      const uniqueCount = getUniqueCount(questions);
      if (rawCount > uniqueCount) {
        toast.warning(
          `Đề gốc có ${rawCount - uniqueCount} câu trùng, chỉ chọn được ${uniqueCount}/${rawCount} câu hợp lệ`
        );
      }
      const existingKeys = new Set(listQuestionsAdded.map((q: any) => getItemKey(q)));
      const newQuestions = (questions || []).filter((q: any) => !existingKeys.has(getItemKey(q)));
      setListQuestionsAdded([...listQuestionsAdded, ...newQuestions]);
    }
  };

  function isChecked(array1: any, array2: any) {
    if (!array2 || array2.length === 0) return false;
    const set1 = new Set((array1 || []).map((item: any) => getItemKey(item)));
    return (array2 || []).every((element: any) => set1.has(getItemKey(element)));
  }

  const handleConfirmQuestion = () => {
    if (valueModalConfirm === "" && valueInputConfirm === 0) {
      toast.error("Vui lòng chọn một trong hai trường hợp");
      return;
    }
    if (valueModalConfirm === "2" && valueInputConfirm === 0) {
      toast.error("Vui lòng nhập số lượng câu hỏi muốn ngẫu nhiên");
      return;
    }

    if (valueModalConfirm === "2") {
      if (Number(valueInputConfirm) > uniqueSelectedCount) {
        toast.error(`Không đủ câu hỏi hợp lệ. Tối đa random ${uniqueSelectedCount} câu`);
        return;
      }
      setInitialRandomCount(Number(valueInputConfirm));
    } else {
      setInitialRandomCount(undefined);
    }
    setOpenModal(false);
    setCreateQuestion(true);
    setIsPickOldExam(false);
  };

  const scrollToExam = (examId: any) => {
    const el = document.getElementById(`exam-card-${examId}`);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <Box style={{ paddingBottom: 40, minHeight: "calc(100vh - 200px)", display: "flex", flexDirection: "column" }}>
      <Grid container spacing={3}>
        {/* LEFT COLUMN: Tóm Tắt & Danh Sách Đề Thi Cũ */}
        <Grid item xs={12} md={4} lg={3}>
          <Paper className={classes.sidebarCard} elevation={0}>
            <div className={classes.sidebarTitle}>
              <ListAltIcon style={{ color: "#2563EB" }} />
              <span>Tóm Tắt Đã Chọn</span>
            </div>

            <div className={classes.statChipRow}>
              <div className={classes.statRowItem} style={{ backgroundColor: "#F8FAFC", color: "#334155" }}>
                <span>Tổng câu đã tích:</span>
                <span style={{ fontWeight: 800, color: "#1E40AF" }}>{listQuestionsAdded.length}</span>
              </div>

              <div className={classes.statRowItem} style={{ backgroundColor: "#FEF3C7", color: "#92400E" }}>
                <span>Câu trùng lặp:</span>
                <span style={{ fontWeight: 800 }}>{listQuestionsAdded.length - uniqueSelectedCount}</span>
              </div>

              <div className={classes.statRowItem} style={{ backgroundColor: "#ECFDF5", color: "#065F46" }}>
                <span>Câu thực tế hợp lệ:</span>
                <span style={{ fontWeight: 800 }}>{uniqueSelectedCount}</span>
              </div>
            </div>

            <Button
              fullWidth
              variant="contained"
              className={classes.btnPrimary}
              onClick={() => setOpenModal(true)}
              disabled={listQuestionsAdded.length === 0}
              style={{ marginBottom: 20 }}
            >
              Xác Nhận Chọn {uniqueSelectedCount} Câu
            </Button>

            <div className={classes.sidebarTitle} style={{ marginTop: 8 }}>
              <LibraryBooksIcon style={{ color: "#2563EB" }} />
              <span>Danh Sách Đề Thi Cũ</span>
            </div>

            <Box display="flex" flexDirection="column">
              {data.map((exam) => (
                <div
                  key={exam.id}
                  className={classes.examNavItem}
                  onClick={() => scrollToExam(exam.id)}
                >
                  <Typography style={{ fontSize: "0.825rem", fontWeight: 700, color: "#0F172A" }} noWrap>
                    {exam.examTitle}
                  </Typography>
                  <Chip
                    label={`${exam.examQuestions?.length || 0} câu`}
                    size="small"
                    style={{ backgroundColor: "#EEF2FF", color: "#4F46E5", fontWeight: 700, fontSize: "0.7rem", height: 20 }}
                  />
                </div>
              ))}
            </Box>
          </Paper>
        </Grid>

        {/* RIGHT COLUMN: Chi Tiết Đề Thi & Danh Sách Câu Hỏi */}
        <Grid item xs={12} md={8} lg={9}>
          {data.map((item) => {
            const isAllSelected = isChecked(listQuestionsAdded, item.examQuestions || []);

            return (
              <div id={`exam-card-${item.id}`} key={item.id}>
                <Accordion TransitionProps={{ timeout: 0 }} className={classes.accordionCard} elevation={0} defaultExpanded>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.accordionSummary}>
                    <Box display="flex" alignItems="center" justifyContent="space-between" width="100%" flexWrap="wrap" style={{ gap: 12 }}>
                      <Box display="flex" alignItems="center" style={{ gap: 12 }}>
                        <LibraryBooksIcon style={{ color: "#2563EB", fontSize: 24 }} />
                        <Box>
                          <Typography style={{ fontWeight: 800, fontSize: "1.05rem", color: "#0F172A" }}>
                            {item.examTitle}
                          </Typography>
                          <Typography style={{ fontSize: "0.8rem", color: "#64748B", marginTop: 2 }}>
                            Ngày tạo: {dateTimeToFormatYYYYHHMM(item.startDate)} • Tổng {item.totalPoint}đ
                          </Typography>
                        </Box>
                      </Box>

                      <Box display="flex" alignItems="center" style={{ gap: 12 }} onClick={(e) => e.stopPropagation()}>
                        <Chip
                          label={`${item.examQuestions?.length || 0} câu hỏi`}
                          size="small"
                          style={{ backgroundColor: "#EEF2FF", color: "#4F46E5", fontWeight: 700 }}
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              color="primary"
                              checked={isAllSelected}
                              onChange={(event) => handleAddAllQuestion(item.examQuestions || [], event)}
                            />
                          }
                          label={<Typography style={{ fontWeight: 700, fontSize: "0.875rem", color: "#334155" }}>Chọn tất cả</Typography>}
                        />
                      </Box>
                    </Box>
                  </AccordionSummary>

                  <AccordionDetails style={{ padding: "20px 24px", display: "flex", flexDirection: "column", gap: 12 }}>
                    {item?.examQuestions?.map((qItem: any, qIdx: number) => {
                      const questionData = qItem.question || qItem;
                      const isSelected = listQuestionsAdded.some((x: any) => getItemKey(x) === getItemKey(qItem));

                      return (
                        <Paper
                          key={qItem.id || qIdx}
                          className={clsx(classes.questionCard, isSelected && classes.questionSelected)}
                          elevation={0}
                          onClick={() => handleAddQuestion(qItem)}
                        >
                          <Box display="flex" justifyContent="space-between" alignItems="flex-start" style={{ gap: 12 }}>
                            <Box flex={1}>
                              <Typography className={classes.questionTitle}>
                                Câu {qIdx + 1}: {questionData.content || questionData.questionContent}
                              </Typography>

                              {/* Images list */}
                              {questionData.imageFileList && questionData.imageFileList.length > 0 && (
                                <Box display="flex" flexWrap="wrap" style={{ gap: 10, margin: "10px 0" }}>
                                  {questionData.imageFileList.map((img: any) => (
                                    <img
                                      key={img.id || img.imageFileID}
                                      src={img.url || img.imageFile?.url}
                                      alt="Question attached"
                                      style={{ maxHeight: 160, borderRadius: 8, objectFit: "cover" }}
                                    />
                                  ))}
                                </Box>
                              )}

                              {/* Answers List */}
                              <Box display="flex" flexDirection="column" style={{ gap: 6, marginTop: 8 }}>
                                {questionData.answers?.map((ans: any, aIdx: number) => (
                                  <Typography
                                    key={aIdx}
                                    className={clsx(classes.answerText, ans.isRightAnswer && classes.answerRightText)}
                                  >
                                    • {ans.content || ans.answerContent}{" "}
                                    {ans.isRightAnswer && <CheckCircleIcon style={{ fontSize: 14, color: "#059669", marginLeft: 4 }} />}
                                  </Typography>
                                ))}
                              </Box>
                            </Box>

                            <FormControlLabel
                              onClick={(e) => e.stopPropagation()}
                              control={
                                <Checkbox
                                  color="primary"
                                  checked={isSelected}
                                  onChange={() => handleAddQuestion(qItem)}
                                />
                              }
                              label={<Typography style={{ fontSize: "0.8rem", fontWeight: 700, color: isSelected ? "#0F766E" : "#64748B" }}>{isSelected ? "Đã chọn" : "Chọn"}</Typography>}
                            />
                          </Box>
                        </Paper>
                      );
                    })}
                  </AccordionDetails>
                </Accordion>
              </div>
            );
          })}
        </Grid>
      </Grid>

      {/* Sticky Bottom Action Bar */}
      <Paper className={classes.stickyFooter} elevation={0}>
        <Button
          variant="outlined"
          startIcon={<ArrowBackIcon />}
          onClick={() => {
            setIsShowMainExam(true);
            setIsPickOldExam(false);
            setListQuestionsAdded([]);
          }}
          className={classes.btnSecondary}
        >
          Quay Lại
        </Button>

        <Button
          variant="contained"
          className={classes.btnPrimary}
          onClick={() => setOpenModal(true)}
          endIcon={<ArrowForwardIcon />}
          disabled={listQuestionsAdded.length === 0}
        >
          Tiếp Theo ({uniqueSelectedCount} Câu)
        </Button>
      </Paper>

      {/* Modal Confirm Question Count */}
      <Dialog open={openModal} onClose={handleClose} maxWidth="xs" fullWidth PaperProps={{ style: { borderRadius: 16 } }}>
        <DialogTitle style={{ borderBottom: "1px solid #E2E8F0", padding: "16px 24px" }}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6" style={{ fontWeight: 800, color: "#0F172A" }}>
              Xác Nhận Số Lượng Câu Hỏi
            </Typography>
            <IconButton size="small" onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>

        <DialogContent style={{ padding: "24px" }}>
          <RadioGroup
            name="oldExam"
            value={valueModalConfirm}
            onChange={(e) => setValueModalConfirm(e.target.value)}
          >
            <FormControlLabel
              value="1"
              control={<Radio color="primary" />}
              label={
                <Typography style={{ fontWeight: 600, color: "#0F172A" }}>
                  Lấy toàn bộ <b>{uniqueSelectedCount} / {uniqueSelectedCount}</b> câu hỏi đã chọn
                </Typography>
              }
              style={{ marginBottom: 12 }}
            />

            <FormControlLabel
              value="2"
              control={<Radio color="primary" />}
              label={
                <Box display="flex" alignItems="center" style={{ gap: 8 }}>
                  <Typography style={{ fontWeight: 600, color: "#0F172A" }}>
                    Lấy ngẫu nhiên
                  </Typography>
                  <input
                    className={classes.inputShuffleModal}
                    type="number"
                    value={valueInputConfirm}
                    onChange={(e) => {
                      const rawValue = e.target.value;
                      if (rawValue === "") {
                        setValueInputConfirm("");
                        return;
                      }
                      const val = Number(rawValue);
                      setValueInputConfirm(val > uniqueSelectedCount ? uniqueSelectedCount : val);
                    }}
                  />
                  <Typography style={{ fontWeight: 600, color: "#0F172A" }}>
                    / {uniqueSelectedCount} câu
                  </Typography>
                </Box>
              }
            />
          </RadioGroup>
        </DialogContent>

        <DialogActions style={{ padding: "16px 24px", borderTop: "1px solid #E2E8F0" }}>
          <Button onClick={handleClose} className={classes.btnSecondary}>
            Hủy Bỏ
          </Button>
          <Button onClick={handleConfirmQuestion} className={classes.btnPrimary}>
            Đồng Ý & Soạn Đề
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
